import { FEATUREKEYS } from "./Featurekeys";

export const NavigationOnPath = {
  "/desk": FEATUREKEYS.Home,
  "/profile": FEATUREKEYS.profile,
  "/attendance": FEATUREKEYS.attendanceLogs,
  "/leave": FEATUREKEYS.leave,
  "/holiday": FEATUREKEYS.holiday,
  "/checklist": FEATUREKEYS.checklist,
  "/policycenter": FEATUREKEYS.employeePolicyCenter,
  "/expense": FEATUREKEYS.employeeExpense,
  "/package_proration": FEATUREKEYS.payroll,

  "/config/hris/company/business_unit": FEATUREKEYS.businessUnit,
  "/config/hris/company/department": FEATUREKEYS.department,
  "/config/hris/company/designation": FEATUREKEYS.designation,
  "/config/hris/company/team": FEATUREKEYS.team,
  "/config/hris/company/grade": FEATUREKEYS.grade,
  "/config/hris/employee/employee_id": FEATUREKEYS.employeeID,
  "/config/hris/employee/probation": FEATUREKEYS.probation,
  "/config/hris/employee/approval_workflow": FEATUREKEYS.approvalWorkflow,
  "/config/hris/employee/default_privacy": FEATUREKEYS.globalProfilePrivacy,
  "/config/hris/employee/default_permission": FEATUREKEYS.defaultPermission,
  "/config/hris/employee/permission_policy": FEATUREKEYS.permissionPolicy,
  "/config/hris/employee/exit_policy": FEATUREKEYS.exitPolicy,
  "/config/hris/employee/exit_reason": FEATUREKEYS.exitReasons,
  "/config/hris/employee/custom_data": FEATUREKEYS.customData,
  "/config/hris/account_management/global_default": FEATUREKEYS.globalDefault,
  "/config/hris/account_management/interface_branding":
    FEATUREKEYS.interfaceBranding,
  "/config/hris/account_management/email_branding": FEATUREKEYS.emailBranding,
  "/config/hris/account_management/company_offices": FEATUREKEYS.companyOffices,
  "/config/hris/account_management/incorporation_details":
    FEATUREKEYS.incorporationDetails,
  "/config/track/attendance/shift/list": FEATUREKEYS.shift,
  "/config/track/attendance/shift": FEATUREKEYS.shift,
  "/config/track/attendance/clockin_method/list": FEATUREKEYS.clockinMethod,
  "/config/track/attendance/clockin_method": FEATUREKEYS.clockinMethod,
  "/config/track/attendance/policy/list": FEATUREKEYS.attendancePolicy,
  "/config/track/attendance/policy": FEATUREKEYS.attendancePolicy,
  "/config/track/attendance/extra_time/list": FEATUREKEYS.extratime,
  "/config/track/attendance/extra_time": FEATUREKEYS.extratime,
  "/config/track/attendance/request_cycle": FEATUREKEYS.requestCycle,
  "/config/track/leave/weeklyoff/list": FEATUREKEYS.weeklyOff,
  "/config/track/leave/weeklyoff": FEATUREKEYS.weeklyOff,
  "/config/track/leave/type": FEATUREKEYS.leavePlan,
  "/config/track/leave/policy/list": FEATUREKEYS.leavePolicy,
  "/config/track/leave/policy": FEATUREKEYS.leavePolicy,
  "/config/track/leave/holiday/list": FEATUREKEYS.leaveHoliday,
  "/config/track/leave/holiday": FEATUREKEYS.leaveHoliday,
  "/config/track/leave/transition": FEATUREKEYS.transition,
  "/config/pay/expense/expense_cycle": FEATUREKEYS.expenseCycle,
  "/config/pay/expense/currency_conversion": FEATUREKEYS.expensecurrency,
  "/config/pay/expense/fuelconfig": FEATUREKEYS.expenseFuel,
  "/config/pay/expense/compensator": FEATUREKEYS.compensator,
  "/config/pay/expense/policy": FEATUREKEYS.expensePolicy,
  "/config/pay/payroll/method": FEATUREKEYS.payrollmethod,
  "/config/pay/payroll/salary_cycle": FEATUREKEYS.salarycycle,
  "/config/pay/payroll/details/signatory": FEATUREKEYS.signatories,
  "/config/pay/payroll/misc/rounding": FEATUREKEYS.misc,
  "/config/pay/payroll/salary_component": FEATUREKEYS.salarycomponent,
  "/config/pay/payroll/salary_structure": FEATUREKEYS.salarystructure,
  "/config/pay/payroll/fbp": FEATUREKEYS.configfbp,
  "/config/pay/payroll/tag": FEATUREKEYS.configtag,
  "/config/pay/payroll/fnf": FEATUREKEYS.fnfconfig,
  "config/pay/payroll/overtimepaymentpolicy": FEATUREKEYS.extrapaymentpolicy,
  "/config/resolve/checklist": FEATUREKEYS.resolve,
  "/config/resolve/policy_center": FEATUREKEYS.configPolicyCenter,
};
